import React, { useEffect } from 'react'
import {
  makeStyles, Theme, List, Menu, MenuItem,
  Collapse, ListItem, ListItemIcon, ListItemText, ListItemProps
} from "@material-ui/core";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
import DescriptionIcon from "@material-ui/icons/Description";
import NotificationsIcon from '@material-ui/icons/Notifications';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ForumIcon from "@material-ui/icons/Forum";
import RecentActorsIcon from '@material-ui/icons/RecentActors';
import Home from '../../../pages/Home'
import QARegist from '../../../pages/QARegist'
import QAList from '../../../pages/QAList'
import QAEdit from '../../../pages/QAEdit'
import ContractList from '../../../pages/ContractList'
import ContractEdit from '../../../pages/ContractEdit'
import Notice from '../../../pages/Notice'
import NotFound from '../../../pages/NotFound'
import { typeMenuList } from "../../../api/helpline/user"
import { useGlobalState, useDispatch, } from '../../../provider/Provider';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import { removeSessionStorage, removeSessionStorageForm, removeSessionStorageConForm, removeSessionStorageCon, adminUser } from '../../../User';
import UncontractList from '../../../pages/UncontractList';
import UncontractCreate from '../../../pages/UncontractCreate';
import UncontractEdit from '../../../pages/UncontractEdit';
import ContractRegist from '../../../pages/ContractRegist';

interface UserPopUpEEProp {
  anchorEl: HTMLElement | null,
  openaccount: boolean,
  handleClose: () => void,
  logOut: () => void,
}

interface MenuListEEProp {
  menuListData: typeMenuList[] | undefined,
  menulistopen: {
    [x: string]: boolean;
  }[] | undefined,
  handleChangeSubMenu: (menuId: string) => void,
  handleListItemClick: (event: React.MouseEvent<HTMLElement, MouseEvent>, text: string) => void,
}

interface PageEEProp {
  value: string,
  update: boolean,
  pagehome: boolean,
  handleListItemClick: (event: React.MouseEvent<HTMLElement, MouseEvent>, text: string) => void
  handleClickQAno: (num: string) => void,
  handleHomeHistory: () => void,
  handleError: (err: any) => void,
  handleListHistory: () => void,
  handleClickHome: () => void,
  handleNotificationOpen: (level: "success" | "info" | "warning" | "error", message: string) => void,
  handleClickKeiyakuno: (num: string) => void,
}

const useStyles = makeStyles((theme: Theme) => ({
  nested: {
    paddingLeft: theme.spacing(4),
  },
})
);

const menuQa = process.env.REACT_APP_MENU_EE_QA!
const menuQaCreate = process.env.REACT_APP_MENU_EE_QA_CREATE!
const menuQaList = process.env.REACT_APP_MENU_EE_QA_LIST!
const menuQaEdit = process.env.REACT_APP_MENU_EE_QA_EDIT!
const menuContract = process.env.REACT_APP_MENU_EE_CONTRACT!
const menuContractList = process.env.REACT_APP_MENU_EE_CONTRACT_LIST!
const menuContractEdit = process.env.REACT_APP_MENU_EE_CONTRACT_EDIT!
const menuUnContract = process.env.REACT_APP_MENU_EE_UNCONTRACT!
const menuUnContractEdit = process.env.REACT_APP_MENU_EE_UNCONTRACT_EDIT!
const menuNotice = process.env.REACT_APP_MENU_EE_NOTICE!
const menuFAQ = process.env.REACT_APP_FAQ_LINK!
const menuUser = process.env.REACT_APP_MENU_AN_USER!
const adminContractList = process.env.REACT_APP_MENU_AN_CONTRACT!
const adminContractRegist = process.env.REACT_APP_MENU_AN_CONTRACT_REGIST!

export const UserPopUpemployee: React.FC<UserPopUpEEProp> = (props) => {
  const { anchorEl, openaccount, handleClose, logOut, } = props
  return (
    <Menu
      id="menu-appbar"
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={openaccount}
      onClose={handleClose}
    >
      <MenuItem onClick={(event) => logOut()}>ログアウト</MenuItem>
    </Menu>
  )
}

//よくある質問MenuのLink
const ListItemLink = (props: ListItemProps<'a', { button?: true }>) => {
  return <ListItem button component="a" {...props} />;
}
export const MenuListemployee: React.FC<MenuListEEProp> = (props) => {
  const globalState = useGlobalState('user')
  const { role } = globalState
  const classes = useStyles()
  const { menuListData, menulistopen, handleChangeSubMenu, handleListItemClick } = props

  return (
    <List>
      {menuListData && (menuListData.map(value => value.menu.map((value) => {
        if (value.menuId !== menuUser) {//ユーザー情報のID
          return (
            <React.Fragment>
              <ListItem button key={value.menuId}
                onClick={event => handleChangeSubMenu(value.menuId)}>
                <ListItemIcon>
                  {value.menuId === menuQa && <ForumIcon />}
                  {value.menuId === menuContract && <DescriptionIcon />}
                  {value.menuId === menuUnContract && <RecentActorsIcon />}
                </ListItemIcon>
                {menulistopen && (menulistopen[value.menuId] ? (
                  <React.Fragment>
                    <ListItemText primary={value.displayName} />
                    <ExpandLess />
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <ListItemText primary={value.displayName} />
                    <ExpandMore />
                  </React.Fragment>
                ))}
              </ListItem>
              {value.menu.map((subvalue) => subvalue.menuId !== adminContractList && (
                <Collapse key={subvalue.menuId} in={menulistopen && (menulistopen[value.menuId])} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem button className={classes.nested}
                      onClick={(event) => handleListItemClick(event, subvalue.menuId)}>
                      <ListItemText primary={subvalue.displayName} />
                    </ListItem>
                  </List>
                </Collapse>
              ))}
            </React.Fragment>
          )
        }
      })))}
      <ListItem button onClick={(event) => handleListItemClick(event, menuNotice)}>
        <ListItemIcon>
          <NotificationsIcon />
        </ListItemIcon>
        <ListItemText primary={'お知らせ'} />
      </ListItem>
      <ListItemLink href={menuFAQ} target="_blank">
        <ListItemIcon>
          <ContactSupportIcon />
        </ListItemIcon>
        <ListItemText primary={"よくある質問"} />
      </ListItemLink>
    </List>
  )
}

export const Pageemployee: React.FC<PageEEProp> = (props) => {
  const globalState = useGlobalState('user')
  const { value, handleListItemClick, handleClickQAno, handleHomeHistory, pagehome, handleError, handleListHistory, handleNotificationOpen, handleClickKeiyakuno, handleClickHome, update } = props
  let { path } = useRouteMatch()
  const history = useHistory()
  const globalconlistState = useGlobalState('contractlist')
  const { backpage } = useGlobalState('page')
  const dispatch = useDispatch()

  const handlePage = (): void => {
    if (value) {
      if (backpage) {
        dispatch({ type: 'SET_PAGE', payload: globalState, page: { backpage: false }, qalist: [], contractlist: globalconlistState })
      }
      removeSessionStorage()
      removeSessionStorageForm()
      removeSessionStorageCon()
      removeSessionStorageConForm()
    }
    switch (value) {
      case menuQaCreate://QA新規登録
        history.push(`${path}/qas/regist`)
        break
      case menuQaList://QA一覧
        history.push(`${path}/qas`)
        break
      case menuNotice://お知らせ
        history.push(`${path}/information`)
        break
      case menuContractList://契約一覧
        history.push(`${path}/contract`)
        break
      case adminContractRegist://契約新規登録
        history.push(`${path}/contract/regist`)
        break
      case menuUnContractEdit://未契約顧客一覧
        history.push(`${path}/uncontractcr`)
        break
      case 'home':
        history.push(`${path}`)
        break
    }
  }
  useEffect(() => {
    handlePage()
  }, [value, update])
  return (
    <Switch>
      <Route exact path={`${path}/qas`} >{/*QA一覧 */}
        <QAList handleClickQAno={handleClickQAno} handleListHistory={handleListHistory} handleError={handleError} />
      </Route>
      <Route exact path={`${path}/information`}>{/*お知らせ */}
        <Notice handleError={handleError} />
      </Route>
      <Route exact path={`${path}/qas/regist`}>{/*QA新規登録 */}
        <QARegist handleNotificationOpen={handleNotificationOpen} handleError={handleError} handleClickHome={handleClickHome} />
      </Route>
      <Route exact path={`${path}/qas/:qano`}>{/*QA編集 */}
        <QAEdit pagehome={pagehome} handleError={handleError} handleNotificationOpen={handleNotificationOpen} />
      </Route>
      <Route exact path={`${path}/contract`}>{/*契約一覧 */}
        <ContractList handleError={handleError} handleClickKeiyakuno={handleClickKeiyakuno} />
      </Route>
      <Route exact path={`${path}/contract/regist`}>{/*契約新規登録 */}
        <ContractRegist handleError={handleError} handleNotificationOpen={handleNotificationOpen} handleClickHome={handleClickHome} />
      </Route>
      <Route exact path={`${path}/contract/:keiyakuno`}>{/*契約詳細編集 */}
        <ContractEdit handleError={handleError} handleClickQAno={handleClickQAno} handleListHistory={handleListHistory} handleNotificationOpen={handleNotificationOpen} handleClickHome={handleClickHome} />
      </Route>
      <Route exact path={`${path}`}>{/*Home */}
        <Home handleListItemClick={handleListItemClick} handleClickQAno={handleClickQAno} handleHomeHistory={handleHomeHistory} handleError={handleError} />
      </Route>
      <Route exact path={`${path}/uncontractcr`}>{/*未契約顧客一覧 */}
        <UncontractList handleError={handleError} />
      </Route>
      <Route exact path={`${path}/uncontractcr/create`}>{/*未契約顧客新規登録 */}
        <UncontractCreate handleError={handleError} handleNotificationOpen={handleNotificationOpen} />
      </Route>
      <Route exact path={`${path}/uncontractcr/:usercd`}>{/*未契約顧客編集 */}
        <UncontractEdit handleError={handleError} handleNotificationOpen={handleNotificationOpen} />
      </Route>
      <Route>
        <NotFound />
      </Route>
    </Switch >
  )
}